import { apiAuth, apiResponseType } from "./index";
import { DashboardFilters } from "@/types/dashboard";

export const getDashboard = (filters?: DashboardFilters): apiResponseType => {
  const queryParams = new URLSearchParams();

  if (filters?.unity_id) {
    if (Array.isArray(filters.unity_id)) {
      filters.unity_id.forEach((id) => {
        queryParams.append("unity_id[]", id.toString());
      });
    } else {
      queryParams.append("unity_id", filters.unity_id.toString());
    }
  }

  if (filters?.seller_id) {
    if (Array.isArray(filters.seller_id)) {
      filters.seller_id.forEach((id) => {
        queryParams.append("seller_id[]", id.toString());
      });
    } else {
      queryParams.append("seller_id", filters.seller_id.toString());
    }
  }

  if (filters?.goal_type) {
    queryParams.append("goal_type", filters.goal_type);
  }

  if (filters?.chart_period) {
    queryParams.append("chart_period", filters.chart_period);
  }

  if (filters?.period) {
    queryParams.append("period", filters.period);
  }

  if (filters?.start_date) {
    queryParams.append("start_date", filters.start_date);
  }

  if (filters?.end_date) {
    queryParams.append("end_date", filters.end_date);
  }

  const queryString = queryParams.toString();
  return apiAuth.get(`dashboard${queryString ? `?${queryString}` : ""}`);
};

export const exportRankingPdf = (data: {
  ranking: Array<{
    seller_id: number;
    seller_name: string;
    total_sales: number;
    total_orders: number;
    daily_goal?: number;
    monthly_goal?: number;
    hit_daily_goal?: boolean;
    hit_monthly_goal?: boolean;
  }>;
  totalSellers: number;
  hitGoalCount: number;
  viewMode: "day" | "month";
  filterHitGoal: boolean;
  goalLabel: string;
}): Promise<Blob> => {
  return apiAuth
    .post(`dashboard/ranking/export-pdf`, data, {
      responseType: "blob",
    })
    .then((response: any) => response.data);
};
